
export const baseUrl = 'https://api.bankmudraa.com/api/'

// dev branch
// export const baseUrl = 'https://dev.bankmudraa.com/api/'

// use for locally

// export const baseUrl = 'http://localhost:3200/api/'
// export const baseUrl = 'https://api.needu.in/api/'
// export const baseUrl = 'http://192.168.1.10:3200/api/'
export const mobileNumberFilter = ['+918228040543', '+917982066566']
// export const razor_pay_key = 'rzp_test_eqxXxwLWaT9WTv'
export const razor_pay_key = 'rzp_live_rECvbdvQy59uju'
export const firebaseApiKey = 'AIzaSyAu-UZVhX5ScmV9IyCiNcBEJ6cZgeHqwtE'
export const firebaseAuthDomain = 'needu-3f340.firebaseapp.com'
export const firebaseProjectId = 'needu-3f340'
export const firebaseStorageBucket = 'needu-3f340.firebasestorage.app'
export const firebaseMessagingSenderId = '847112031066'
export const firebaseAppId = '1:847112031066:web:72628698937c34fd0d8163'
export const firebaseMeasurementId = 'G-RY5X7X3S5X'
export const firebaseVapidKey = 'BHaGFehWhqyDb8i4GmE220QoB_7TZdWtxaH8FrKIjDg3Q4kAcb0-p9cOAGhMCi4GREadlekIl1vFpX-4cM9J8Gg'

export const baseUrlImage = 'https://api.bankmudraa.com/api/cloudinary/'
// export const baseUrlImage = 'https://api.needu.in/api/cloudinary/'
